import React, { Component } from 'react';
import {Link} from 'react-router-dom'


export const SUBJECT_TYPE = {
    2: { // 速算
        '0': '数学',
        '10': '科学'
    },
    4: { // ai直播课
        '0': '数学'
    },
    5: { // 直播课
        '0': '数学'
    },
    6: { // 语文
        '1': '语文'
    },
    7: { // 英语
        '2': '英语'
    },
    11: { // 素质课
        '51': '素质课'
    }
};

// 配置项
export const RELATE_WORD = '英语词汇';
export const RELATE_SENTENCE = '英语句型';
export const RELATE_MAP = {
    relate_word: '英语词汇',
    relate_sentence: '英语句型'
};
export const CONFIGURATION_ITEM = { // 配置项相关配置
    21: 'knowledge',
    122: 'issue',
    24: 'ability',
    [RELATE_WORD]: 'relate_word',
    [RELATE_SENTENCE]: 'relate_sentence',
};

// 内容录入方式
export const contentInputType = (type) => {
    let selectType = [];
    switch (type) {
        case 'english_guide':
        case 'english_tiptext':
            selectType = [
                {
                    text: 'text',
                    name: '文本框'
                }
            ];
            break;
        case 'english_text':
            selectType = [
                {
                    text: 'text',
                    name: '文本框'
                },
                {
                    text: 'rich_text',
                    name: '富文本编辑器'
                }
            ];
            break;
        case 'english_picture': 
            selectType = [
                {
                    text: 'image',
                    name: '上传图片'
                },
                {
                    text: 'rich_text',
                    name: '富文本编辑器'
                }
            ];
            break;
        case 'english_audio':
            selectType = [
                {
                    text: 'audio',
                    name: '上传音频'
                },
                {
                    text: 'rich_text',
                    name: '富文本编辑器'
                }
            ];
            break;
        default: 
            selectType = [
                {
                    text: 'rich_text',
                    name: '富文本编辑器'
                }
            ];
    }

    return selectType;
};

export const OPTION_INPUT_TYPE = [
    {
        text: 'text',
        name: '文本框'
    },
    {
        text: 'rich_text',
        name: '富文本编辑器'
    },
    {
        text: 'image',
        name: '上传图片'
    },
    {
        text: 'audio',
        name: '上传音频'
    }
];

export const DISPLAT_QUESTION_TYPE = {
    'select': [
        {
            id: '224',
            name: '听力选择题',
        },
        {
            id: '201',
            name: '笔试选择题',
        }
    ],
    'judge': [
        {
            id: '227',
            name: '听力判断题',
        },
        {
            id: '205',
            name: '笔试判断题',
        }
    ]
};

export const LETTER_MAP = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O"];


export const statusList=[{
	label:'全部',
	value:'-1'
},{
	label:'编辑中',
	value:'0'
},{
	label:'使用中',
	value:'1'
}]
export const questionTypeList=[{
	label:'全部',
	value:'-1'
},{
	label:'选择题',
	value:'21'
},{
	label:'判断题',
	value:'25'
}]

export const tableColumns = [{
  title: '模板ID',
  dataIndex:'temp_id',
  key: 'temp_id',
  width:80,
  index:1,
}, {
  title: '模板名',
  	dataIndex: 'name',
  	key: 'name',
  	index:2,
  	render: (text, record) => {
  		return <a target="_blank" href={`#/questionTML/${record.temp_id}`}>{text}</a>;
  	}
},{
  title: '题型',
  key: 'type_show',
  dataIndex: 'type_show',
  width:80, 
}, {
  title: '状态',
  key: 'stage',
  dataIndex: 'stage',
  width:80,
  index:5,
},{
  title: '创建人',
  key: 'create_user',
  dataIndex: 'create_user',
  width:80,
  index:6,
},{
  title: '更新时间',
  key: 'update_time',
  width:150,
  dataIndex: 'update_time',
},{
  title: '创建时间',
  key: 'create_time',
  dataIndex: 'create_time',
  width:150,
  index:8,
}];

export const TYPE_SHOW = {
    'select': 21,
    'judge': 25
}

export const TYPE_SHOW_REVERSE = {
    21: 'select',
    25: 'judge'
}





// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_tml/constData/index.js